import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import PreMarketDashboard from './components/PreMarketDashboard';
import TrendingDashboard from './components/TrendingDashboard';
import SocialBuzzDashboard from './components/SocialBuzzDashboard';
import MonstersDashboard from './components/MonstersDashboard';
import AuthBanner from './components/AuthBanner';
import AppV2 from './AppV2';
import './AppWithRouter.css';

// Original (legacy) dashboard — now served under /legacy/*
function V1Layout() {
  return (
    <div className="app-root">
      <AuthBanner />
      <header className="global-header">
        <div className="header-brand">
          <h1>🦔 Hedgehog Trading (Legacy)</h1>
        </div>
        <nav className="header-nav">
          <NavLink to="/legacy/dashboard/premarket" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            📊 Pre-Market Scanner
          </NavLink>
          <NavLink to="/legacy/dashboard/trending" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            🔥 Trending Stocks
          </NavLink>
          <NavLink to="/legacy/dashboard/social-buzz" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            📱 Social Buzz
          </NavLink>
          <NavLink to="/legacy/dashboard/monsters" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            🐲 Monsters
          </NavLink>
          <NavLink to="/" className="nav-link" style={{ color: '#fbbf24' }}>
            ✨ New Dashboard
          </NavLink>
        </nav>
        <div className="header-info">
          <span className="time">{new Date().toLocaleTimeString()}</span>
        </div>
      </header>
      <div className="app-content">
        <Routes>
          <Route index element={<Navigate to="/legacy/dashboard/premarket" replace />} />
          <Route path="dashboard/premarket" element={<PreMarketDashboard />} />
          <Route path="dashboard/trending" element={<TrendingDashboard />} />
          <Route path="dashboard/social-buzz" element={<SocialBuzzDashboard />} />
          <Route path="dashboard/monsters" element={<MonstersDashboard />} />
          <Route path="*" element={<Navigate to="/legacy/dashboard/premarket" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function AppWithRouter() {
  return (
    <Router>
      <Routes>
        {/* Original view preserved under /legacy */}
        <Route path="/legacy/*" element={<V1Layout />} />
        {/* V2 dark-themed dashboard (now the default) */}
        <Route path="/v2/*" element={<AppV2 />} />
        {/* Root and anything else -> V2 default */}
        <Route path="*" element={<Navigate to="/v2/dashboard/monsters" replace />} />
      </Routes>
    </Router>
  );
}

export default AppWithRouter;
